import React from "react";
import { InputLabel, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomTextField = styled(TextField)({
  '& .MuiInputBase-root': {
    maxHeight: '35px', 
  },
});

const Input = ({
  label,
  name,
  errorMessage,
  disabled,
  value,
  textAlign,
  type,
  onChange,
  onBlur,
  required=false,
  error
}) => {

  return (
    <>
      <div className="base-input">
        <InputLabel htmlFor={name} sx={{
          fontWeight: '800', 
          lineHeight: '33.6px',
          color: '#6b7280',
          fontFamily: 'Nunito',
          fontSize: '14px',
          fontStyle: 'normal',
        }}>
          {label}
        </InputLabel>
        <div>
        <CustomTextField
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          type={type}
          disabled={disabled}
          error={!!errorMessage}
          helperText={errorMessage}
          fullWidth
          required={required}
          InputProps={{
            inputProps: {
              style: {
                textAlign: textAlign,
              },
            },
            style: {
              backgroundColor: disabled ? "#e8e6ed" : null,
            },
          }}
          variant="outlined"
        />
        </div>
      </div>
    </>
  );
};

export default Input;

// import React, { useState, useRef, forwardRef } from "react";
// import { InputLabel, TextField } from "@mui/material";
// import { styled } from "@mui/material/styles";

// const CustomTextField = styled(TextField)({
//   '& .MuiInputBase-root': {
//     maxHeight: '35px',
//     width: '50px',
//     marginRight: '5px',
//     textAlign: 'center',
//   },
//   '& input': {
//     textAlign: 'center',
//   },
// });

// const Input = forwardRef(({ label, name, errorMessage, disabled, value, textAlign, type, onChange, onBlur }, ref) => {
//   const [inputValues, setInputValues] = useState(Array(6).fill(""));
//   const inputRefs = useRef([]);

//   const handleChange = (index, event) => {
//     const { value } = event.target;
//     if (value.length > 1) return;

//     const updatedValues = [...inputValues];
//     updatedValues[index] = value;
//     setInputValues(updatedValues);

//     const combinedValue = updatedValues.join("");
//     if (onChange) onChange({ target: { name, value: combinedValue } });

//     if (value && index < inputRefs.current.length - 1) {
//       inputRefs.current[index + 1].focus();
//     }
//   };

//   const handlePaste = (event) => {
//     const pasteData = event.clipboardData.getData("text").slice(0, 6);
//     const updatedValues = pasteData.split("").concat(Array(6).fill("")).slice(0, 6);
//     setInputValues(updatedValues);

//     const combinedValue = updatedValues.join("");
//     if (onChange) onChange({ target: { name, value: combinedValue } });

//     const nextIndex = pasteData.length - 1;
//     if (inputRefs.current[nextIndex]) {
//       inputRefs.current[nextIndex].focus();
//     }

//     event.preventDefault();
//   };

//   return (
//     <div className="base-input" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//       <InputLabel
//         htmlFor={name}
//         sx={{
//           fontWeight: "800",
//           lineHeight: "33.6px",
//           color: "#6b7280",
//           fontFamily: "Nunito",
//           fontSize: "14px",
//           fontStyle: "normal",
//           marginBottom: '8px',
//         }}
//       >
//         {label}
//       </InputLabel>
//       <div style={{ display: 'flex', justifyContent: 'center' }}>
//         {inputValues.map((val, index) => (
//           <CustomTextField
//             key={index}
//             inputRef={(el) => {
//               inputRefs.current[index] = el;
//               if (index === 0 && ref) ref.current = el; // Forward the ref to the first input box
//             }}
//             name={`${name}-${index}`}
//             value={val}
//             onChange={(e) => handleChange(index, e)}
//             onBlur={onBlur}
//             type={type}
//             disabled={disabled}
//             error={!!errorMessage}
//             helperText={index === 0 ? errorMessage : ""}
//             InputProps={{
//               inputProps: {
//                 style: {
//                   textAlign: 'center',
//                 },
//                 maxLength: 1,
//               },
//               style: {
//                 backgroundColor: disabled ? "#e8e6ed" : null,
//               },
//             }}
//             onPaste={index === 0 ? handlePaste : undefined}
//             variant="outlined"
//           />
//         ))}
//       </div>
//     </div>
//   );
// });

// export default Input;
